/**
 * Whether to use hCaptcha to protect the login-data and email availability endpoints
 */ export var ENABLE_HCAPTCHA_FOR_LOGIN_DATA_230817 = 'ENABLE_HCAPTCHA_FOR_LOGIN_DATA_230817';
